import { EventPropertyFilter, EventTypeDateTimeProperty } from "@/types";
import { createListStore } from "./list";
import { EventsService } from "@/services/events";
import { toastController } from "@ionic/vue";
import { AxiosError } from "axios";

export const useEventsStore = createListStore(
  "events",
  EventsService,
  {},
  {
    eventsCount: 0,
  },
  {
    async retrieveEvents(
      eventTypeId: string | null,
      filters: EventPropertyFilter[],
      isComplete: boolean | undefined = undefined,
      page: number,
      asc: boolean,
      sortProperty: string | undefined,
      teamId: number | undefined,
      dateTimeEventPropertyTypesByEventType: Record<
        string,
        EventTypeDateTimeProperty
      >,
      flush = false
    ) {
      this.loading = true;
      const { events, count } = await EventsService.fetchAll({
        eventTypeId,
        filters,
        isComplete,
        page,
        asc,
        sortProperty,
        teamId,
      });

      if (count !== undefined) {
        this.eventsCount = count;
      }

      this.merge(events, flush);
      this.loading = false;
    },
  },
  true,
  undefined,
  {
    async onCreatedError(error, options) {
      const { t } = window.globalI18n;
      await options.store.remove(options.entity, true);

      const data = ((error as Error)?.cause as AxiosError)?.response?.data as {
        reason?: string;
      };

      if (data?.reason === "eventTypeIsNotActive") {
        const toast = await toastController.create({
          message: t(
            "events.toast.errors.failedToCreateEventBecauseEventTypeIsNotActive"
          ),
          duration: 2000,
          color: "danger",
        });
        toast.present();
      } else {
        const toast = await toastController.create({
          message: t("events.toast.errors.failedToCreateEvent"),
          duration: 2000,
          color: "danger",
        });
        toast.present();
      }
    },
    async onDeletedError(_error, options) {
      const { t } = window.globalI18n;
      const toast = await toastController.create({
        message: t("events.toast.errors.failedToDeleteEvent"),
        duration: 2000,
        color: "danger",
      });
      toast.present();
      options.store.merge([options.entity]);
    },
  }
);
